import * as Yup from 'yup';
import { loadingCodes } from '../../utils/constants/loadingCodes';
import { FACILITY_TYPES } from '../../utils/constants/facilityTypes';

// prevádzkový denník sa vedie len pre kódy nakladania R (zhodnocovanie) a D (zneškodňovanie) - vyhláška 366/2015 Z. z.
const OPERATIONAL_LOG_LOADING_CODE_CATEGORIES = ['Zhodnocovanie odpadu', 'Zneškodňovanie odpadov'];

export const LOADING_CODE_OPTIONS = Object.entries(loadingCodes)
    .filter(([category]) => OPERATIONAL_LOG_LOADING_CODE_CATEGORIES.includes(category))
    .map(([category, codes]) => ({
        label: category,
        options: codes.map((code) => ({ value: code.value, label: `${code.value} - ${code.label}` })),
    }));

const LOADING_CODE_VALUES = LOADING_CODE_OPTIONS.flatMap((group) => group.options.map((option) => option.value));

export const formValues = {
    branchId: '',
    facilityType: '',
    consentId: '',
    loadingCode: '',
    name: '',
    responsiblePersons: [''],
    defaultResponsiblePersons: [],
    defaultOperatingHoursFrom: '',
    defaultOperatingHoursTo: '',
};

const TIME_REGEX = /^([01]\d|2[0-3]):([0-5]\d)$/;

export const validation = Yup.object({
    branchId: Yup.string().required('Prevádzka je povinná.'),
    facilityType: Yup.string()
        .oneOf(Object.values(FACILITY_TYPES), 'Neplatný typ zariadenia.')
        .required('Typ zariadenia je povinný.'),
    consentId: Yup.string().required('Súhlas je povinný.'),
    loadingCode: Yup.string()
        .oneOf(LOADING_CODE_VALUES, 'Neplatný kód nakladania.')
        .required('Kód nakladania je povinný.'),
    name: Yup.string()
        .min(2, 'Minimálna dĺžka sú 2 znaky.')
        .max(150, 'Maximálna dĺžka je 150 znakov.')
        .required('Názov denníka je povinný.'),
    defaultOperatingHoursFrom: Yup.string().matches(TIME_REGEX, { message: 'Zadajte čas vo formáte HH:MM.', excludeEmptyString: true }).notRequired(),
    defaultOperatingHoursTo: Yup.string().matches(TIME_REGEX, { message: 'Zadajte čas vo formáte HH:MM.', excludeEmptyString: true }).notRequired(),
});
